export class NavigationServiceV1Impl {
    constructor(historyService, logger, options) {
        this.historyService = historyService;
        this.logger = logger;
        this.options = options;
    }
    navigateTo(pageName, locationsByConfigId, anchor) {
        const page = this.options.pages[pageName];
        if (!page) {
            this.logger.debug(`Unable to find the matching page id ${pageName} in map of navigable pages:`, this.options.pages);
            return undefined;
        }
        const featureAppConsumerLocations = [];
        for (const [configId, locationOrPathname] of Object.entries(locationsByConfigId)) {
            const historyKey = page.featureApps[configId];
            if (!historyKey) {
                this.logger.debug(`Could not find history key for feature app config name (aka title) ${configId} among the feature apps for the given page id ${pageName}:`, page.featureApps);
                continue;
            }
            const location = typeof locationOrPathname === "string"
                ? { pathname: locationOrPathname }
                : locationOrPathname;
            featureAppConsumerLocations.push({ historyKey, location });
        }
        return this.navigateByConsumerLocations(pageName, featureAppConsumerLocations, anchor);
    }
    navigateRelativelyByConsumerLocations(featureAppConsumerLocations, anchor) {
        // this is a url relative to current prrimary location
        const primaryLocation = this.options.primaryConsumerLocation();
        const primaryConsumerLocation = {
            historyKey: this.options.primaryConsumerId,
            location: {
                pathname: primaryLocation.pathname,
                hash: anchor,
                search: primaryLocation.search
            }
        };
        const rootLocation = this.historyService.createNewRootLocationForMultipleConsumers(...featureAppConsumerLocations, primaryConsumerLocation);
        return this.navigateToRootLocation(rootLocation);
    }
    navigateByConsumerLocations(pageName, featureAppConsumerLocations, anchor) {
        if (this.options.onNavigate) {
            this.options.onNavigate(pageName);
        }
        const page = this.options.pages[pageName];
        const primaryLocation = {
            historyKey: this.options.primaryConsumerId,
            location: { pathname: page.path, hash: anchor }
        };
        const rootLocationDescriptorObject = this.historyService.createNewRootLocationForMultipleConsumers(...featureAppConsumerLocations, primaryLocation);
        return this.navigateToRootLocation(rootLocationDescriptorObject);
    }
    navigateToRootLocation(rootLocation) {
        const rootHistory = this.historyService.rootHistory;
        return {
            createHref() {
                return rootHistory.createHref(rootLocation);
            },
            push() {
                if (rootLocation.pathname && rootLocation.pathname.startsWith("http")) {
                    const href = this.createHref();
                    window.location.href = href;
                }
                else {
                    rootHistory.push(rootLocation);
                }
            },
            replace() {
                if (rootLocation.pathname && rootLocation.pathname.startsWith("http")) {
                    const href = this.createHref();
                    window.location.href = href;
                }
                else {
                    rootHistory.replace(rootLocation);
                }
            }
        };
    }
}
